import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "flex border pl-2 items-center bg-white rounded-2xl" }
const _hoisted_2 = { class: "text-3xl mr-2" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]

import { ref } from "vue" 


export default /*#__PURE__*/_defineComponent({
  __name: 'listSearch',
  emits: ["searchTermChanged"],
  setup(__props, { emit: __emit }) {

const searchTerm = ref<string>("")

const searchTermChange = () => {
    console.log(searchTerm.value)
    emits("searchTermChanged", searchTerm.value)
}

// const props = defineProps(["searchTerm"])
const emits = __emit


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, [
      (searchTerm.value === '')
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            width: "16",
            src: require('../../assets/icons/search.png'),
            alt: "arama"
          }, null, 8, _hoisted_3))
        : (_openBlock(), _createElementBlock("img", {
            key: 1,
            width: "16",
            src: require('../../assets/icons/search-active.png'),
            alt: "arama"
          }, null, 8, _hoisted_4))
    ]),
    _withDirectives(_createElementVNode("input", {
      type: "text",
      onInput: searchTermChange,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchTerm).value = $event)),
      class: "w-full outline-none text-2xl rounded-xl p-3"
    }, null, 544), [
      [_vModelText, searchTerm.value]
    ])
  ]))
}
}

})